import { useEffect, useState } from "react";
import styled from "styled-components";
import assets from "../../utils/ImagesPath";
import LS_SERVICE from "../../utils/localStorage";
import { LOGIN, VERIFY_OTP, SENT_OTP } from "../../constants/api";
import { Form, Input, Spin, Button } from "antd";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { postAPI, displayMessage } from "../../utils/common";
import {
  CREATOR_LINK,
  CREATOR_NAME,
  PROJECT_NAME,
} from "../../constants/constent";
import { Link } from "react-router-dom";

const Login = () => {
  const [companyName] = useState(PROJECT_NAME);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  const [formType, setFormType] = useState("login"); // 'login' | 'forgot' | 'otp'
  const [loading, setLoading] = useState(false);
  const [mobile, setMobile] = useState(null);

  const images = assets.backgrounds;
  const otaLogos = [
    assets.fevicon,
    assets.agoda,
    assets.airbnb,
    assets.bookingcom,
    assets.booking_engine,
    assets.expedia,
    assets.goibibo,
    assets.makemytrip,
  ];

  useEffect(() => {
    const interval = setInterval(changeBackgroundImage, 10000);
    return () => clearInterval(interval);
  }, [currentIndex, images.length]);

  const changeBackgroundImage = () => {
    setVisible(false);
    setTimeout(() => {
      setCurrentIndex((currentIndex + 1) % images.length);
      setVisible(true);
    }, 1000); // 1 second fade-out
  };

  const handleForgotClick = () => {
    setFormType("forgot");
  };

  const handleOpenLink = () => {
    window.open(CREATOR_LINK, "_blank", "noopener,noreferrer");
  };
  const handleLoginFinish = (values) => {
    setLoading(true);
    const data = new FormData();
    data.append("email", values.username);
    data.append("password", values.password);
    data.append("user_type", "Admin");
    const successFn = function (data) {
      if (data["status"] === true) {
        if (data["user"]["user_type"] === "customer") {
          setLoading(false);
          displayMessage(
            ERROR_MSG_TYPE,
            "Customer accounts are restricted from accessing this portal."
          );
        } else {
          LS_SERVICE.set("id", data["user"]["id"]);
          LS_SERVICE.set("name", data["user"]["name"]);
          LS_SERVICE.set("user_type", data["user"]["user_type"]);
          LS_SERVICE.set("phone", data["user"]["phone"]);
          LS_SERVICE.set("email", data["user"]["email"]);
          LS_SERVICE.set("token", data["token"]);
          LS_SERVICE.set("isCustomer", false);
          setLoading(false);
          displayMessage(
            SUCCESS_MESSAGE,
            data["message"] ?? "Login successful! Redirecting..."
          );
          window.location.reload();
        }
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data["message"] ?? "Fail to Login");
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Fail to Login");
    };
    postAPI(LOGIN, data, successFn, errorFn);
  };

  const handleForgotFinish = (values) => {
    const { mobile } = values;
    if (mobile.length === 10) {
      setLoading(true);
      const data = new FormData();
      data.append("mobileNo", mobile);
      const successFn = function (data) {
        if (data["status"] === true) {
          setMobile(mobile);
          setFormType("otp");
          setLoading(false);
          displayMessage(SUCCESS_MESSAGE, data["message"]);
        } else {
          setLoading(false);
          displayMessage(ERROR_MSG_TYPE, data["message"]);
        }
      };
      const errorFn = function () {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Failed to send OTP.");
      };
      postAPI(SENT_OTP, data, successFn, errorFn);
    } else {
      displayMessage(ERROR_MSG_TYPE, "Enter valid 10-digit mobile number.");
    }
  };

  const handleOtpFinish = (values) => {
    const { otp } = values;
    if (otp.length === 4) {
      setLoading(true);
      const data = new FormData();
      data.append("mobileNo", mobile);
      data.append("otp", otp);
      const successFn = function (data) {
        if (data["status"] === true) {
          setLoading(false);
          setMobile(null);
          setFormType("login");
          displayMessage(SUCCESS_MESSAGE, data["message"]);
        } else {
          setLoading(false);
          displayMessage(ERROR_MSG_TYPE, data["message"]);
        }
      };
      const errorFn = function () {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "OTP verification failed.");
      };
      postAPI(VERIFY_OTP, data, successFn, errorFn);
    } else {
      displayMessage(ERROR_MSG_TYPE, "Enter valid 4-digit OTP.");
    }
  };

  return (
    <StyledWrapper>
      {/* RIGHT — form column */}
      <div className="form-container">
        {/* circle element in the top-right corner with the fevicon inside */}
        <div className="corner-circle" aria-hidden="true">
          <img
            className="form-logo-mark"
            src={assets.fevicon}
            alt={companyName}
          />
        </div>

        {/* decorative drip shape pinned to the bottom */}
        <svg
          className="deco deco-bottom"
          viewBox="0 0 600 120"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <path
            fill="#1e293b"
            d="M0,120 L600,120 L600,60
               C580,56 560,70 540,52 C520,34 500,74 480,54
               C460,34 440,72 420,50 C400,30 380,70 360,52
               C340,34 320,72 300,50 C280,30 260,70 240,52
               C220,34 200,72 180,50 C160,30 140,70 120,52
               C100,34 80,72 60,50 C40,32 20,66 0,58 Z"
          />
        </svg>

        {/* credit footer sitting on top of the bottom drip */}
        <p className="form-footer">
          {PROJECT_NAME} ©{new Date().getFullYear()} · Powered by{" "}
          <Link onClick={handleOpenLink} to="#">
            {CREATOR_NAME}
          </Link>
        </p>

        <div className="form-inner">
          <p className="title">
            {formType === "login" && "Welcome back"}
            {formType === "forgot" && "Reset your password"}
            {formType === "otp" && "Verify your identity"}
          </p>
          <p className="subtitle">
            {formType === "login" && "Sign in to continue to your dashboard"}
            {formType === "forgot" &&
              "Enter your registered mobile number to receive a verification code"}
            {formType === "otp" &&
              "Enter the 4-digit OTP sent to your registered email"}
          </p>
          <Spin spinning={loading}>
          {formType === "login" && (
            <Form
              layout="vertical"
              className="form"
              onFinish={handleLoginFinish}
            >
              <Form.Item
                name="username"
                rules={[
                  {
                    required: true,
                    message: "Please enter your username/phone/email!",
                  },
                ]}
              >
                <Input
                  className="input"
                  placeholder="Enter Username/Phone/Email"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  { required: true, message: "Please enter your password" },
                ]}
              >
                <Input.Password
                  className="input"
                  placeholder="Enter Password"
                />
              </Form.Item>

              <p className="page-link">
                <span className="page-link-label" onClick={handleForgotClick}>
                  Forgot Password?
                </span>
              </p>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="form-btn"
                  block
                  loading={loading}
                >
                  Log in
                </Button>
              </Form.Item>
            </Form>
          )}

          {formType === "forgot" && (
            <Form
              layout="vertical"
              className="form"
              onFinish={handleForgotFinish}
            >
              <Form.Item
                name="mobile"
                rules={[
                  {
                    required: true,
                    message: "Please enter your mobile number",
                  },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: "Mobile number must be 10 digits",
                  },
                ]}
              >
                <Input className="input" placeholder="Enter Mobile Number" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="form-btn"
                  block
                  loading={loading}
                >
                  Send OTP
                </Button>
              </Form.Item>
              <p className="page-link" style={{ textAlign: "center" }}>
                <span
                  className="page-link-label"
                  onClick={() => setFormType("login")}
                >
                  Back to Login
                </span>
              </p>
            </Form>
          )}

          {formType === "otp" && (
            <Form layout="vertical" className="form" onFinish={handleOtpFinish}>
              <Form.Item name="mobile">
                <Input
                  disabled
                  defaultValue={mobile}
                  className="input"
                  placeholder="Enter Mobile Number"
                />
              </Form.Item>
              <Form.Item
                name="otp"
                rules={[
                  { required: true, message: "Please enter the OTP" },
                  {
                    pattern: /^[0-9]{4}$/,
                    message: "OTP must be 4 digits",
                  },
                ]}
              >
                <Input
                  className="input"
                  placeholder="Enter 4-digit OTP"
                  maxLength={4}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="form-btn"
                  block
                  loading={loading}
                >
                  Verify OTP
                </Button>
              </Form.Item>
              <p className="page-link" style={{ textAlign: "center" }}>
                <span
                  className="page-link-label"
                  onClick={() => setFormType("login")}
                >
                  Back to Login
                </span>
              </p>
            </Form>
          )}
          </Spin>

          {/* OTA partner logos marquee */}
          <div className="partner-marquee">
            <p className="partner-label">Integrated with</p>
            <div className="marquee-viewport">
              <div className="marquee-track">
                {[...otaLogos, ...otaLogos].map((src, i) => (
                  <span className="marquee-item" key={i}>
                    <img src={src} alt="partner" />
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* RIGHT — SaaS showcase panel (gradient + slider accent) */}
      <div className="showcase">
        <div
          className={`showcase-bg ${visible ? "visible" : ""}`}
          style={{ backgroundImage: `url(${images[currentIndex]})` }}
        />
        <div className="showcase-overlay" />
        <div className="showcase-glow" />

        {/* logo sign hanging from the top on a thread */}
        <div className="hanging-brand" aria-hidden="true">
          <span className="hang-thread" />
          <div className="hang-card">
            <img
              className="showcase-mark"
              src={assets.logo}
              alt={companyName}
            />
          </div>
        </div>

        <div className="showcase-content">
          <h2 className="showcase-title">
            Run your hotel from one simple dashboard.
          </h2>
          <p className="showcase-sub">
            Manage bookings, rooms, guests, billing and reports — all in real
            time, from anywhere.
          </p>

          <ul className="feature-list">
            <li>
              <span className="tick">✓</span> Real-time reservations &amp;
              calendar
            </li>
            <li>
              <span className="tick">✓</span> Instant invoicing &amp; payments
            </li>
            <li>
              <span className="tick">✓</span> OTA Channel Manager
            </li>
            <li>
              <span className="tick">✓</span> QR Sharing — collect ratings via a
              single link
            </li>
            <li>
              <span className="tick">✓</span> Kitchen &amp; Laundry Management
            </li>
            <li>
              <span className="tick">✓</span> AI Smart Price Management
            </li>
          </ul>
        </div>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  --text: #0f172a;
  --muted: #6b7280;
  --border: #e5e7eb;
  --field-bg: #ffffff;
  --ring: rgba(217, 83, 79, 0.14);

  position: relative;
  height: 100vh;
  width: 100%;
  display: flex;
  overflow: hidden;
  /* dark base so any sub-pixel seam blends with the showcase, not white */
  background: #1e293b;
  font-family: "Inter", "Segoe UI", -apple-system, BlinkMacSystemFont,
    "Helvetica Neue", sans-serif;
  color: var(--text);

  * {
    box-sizing: border-box;
  }

  /* ===================================================================
     RIGHT — form column (SaaS style, centered, airy)
     =================================================================== */
  .form-container {
    position: relative;
    z-index: 2;
    order: 2;
    flex: 0 0 30%;
    max-width: 30%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    overflow: hidden;
    /* subtle texture so the panel isn't a flat white void */
    background: radial-gradient(
        120% 120% at 100% 0%,
        rgba(15, 23, 42, 0.05) 0%,
        transparent 45%
      ),
      radial-gradient(
        100% 100% at 0% 100%,
        rgba(217, 83, 79, 0.05) 0%,
        transparent 50%
      ),
      #ffffff;
  }

  /* ---------- Top-right corner circle + fevicon ---------- */
  .corner-circle {
    position: absolute;
    top: 0;
    right: 0;
    /* pulled out so ~40% is hidden off-corner and ~60% stays visible */
    transform: translate(40%, -40%);
    width: 220px;
    height: 220px;
    border-radius: 50%;
    /* dark slate matching the left showcase side */
    background: linear-gradient(145deg, #0f172a 0%, #1e293b 55%, #334155 100%);
    box-shadow: 0 18px 40px -18px rgba(15, 23, 42, 0.55);
    z-index: 1;
  }

  /* fevicon in the circle's visible lower-left area.
     grey by default, full color on hover (like the Integrated logos) */
  .corner-circle .form-logo-mark {
    position: absolute;
    bottom: 46px;
    left: 46px;
    width: 56px;
    height: 56px;
    object-fit: contain;
    user-select: none;
    /* pure white by default */
    filter: brightness(0) invert(1);
    opacity: 1;
    transition: filter 0.25s ease, opacity 0.25s ease;
  }

  .corner-circle:hover .form-logo-mark {
    /* original color on hover */
    filter: none;
    opacity: 1;
  }

  /* ---------- Decorative drip shape pinned to the bottom ---------- */
  .deco {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 0;
    pointer-events: none;
    display: block;
  }

  /* solid block with a torn edge rising from the bottom */
  .deco-bottom {
    bottom: 0;
    height: 150px;
  }

  /* credit footer on top of the bottom drip */
  .form-footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 30px;
    z-index: 1;
    margin: 0;
    padding: 0 24px;
    text-align: center;
    font-size: 12px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.8);
  }

  .form-footer a {
    color: #fff;
    font-weight: 600;
    text-decoration: none;
  }

  .form-footer a:hover {
    text-decoration: underline;
  }

  /* form content stays above the decorations */
  .form-inner {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 380px;
    animation: rise 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;
  }

  @keyframes rise {
    from {
      opacity: 0;
      transform: translateY(12px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .title {
    position: relative;
    text-align: start;
    margin: 0 0 8px 0;
    padding-top: 18px;
    font-size: 30px;
    font-weight: 800;
    letter-spacing: -0.6px;
    color: var(--text);
  }

  /* small brand accent bar above the heading */
  .title::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 44px;
    height: 4px;
    border-radius: 999px;
    background: var(--primary-color);
  }

  .subtitle {
    text-align: start;
    font-size: 15px;
    line-height: 1.5;
    color: var(--muted);
    margin: 0 0 32px 0;
  }

  .form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-bottom: 4px;
  }

  .form .ant-form-item {
    margin-bottom: 18px;
  }

  /* ---------- Inputs ---------- */
  /* Plain text input + the password wrapper share one outer box */
  .input.ant-input,
  .input.ant-input-affix-wrapper {
    border-radius: 10px;
    border: 1px solid var(--border);
    background: var(--field-bg);
    outline: 0 !important;
    padding: 12px 15px;
    font-size: 15px;
    color: var(--text);
    transition: border-color 0.18s ease, box-shadow 0.18s ease;
  }

  /* The inner input of the password field must be borderless/transparent
     so it does NOT render a second box inside the wrapper */
  .input.ant-input-affix-wrapper > .ant-input {
    border: 0 !important;
    outline: 0 !important;
    box-shadow: none !important;
    background: transparent !important;
    padding: 0 !important;
    font-size: 15px;
    color: var(--text);
    border-radius: 0;
  }

  /* password eye icon */
  .input.ant-input-affix-wrapper .ant-input-suffix,
  .input.ant-input-affix-wrapper .anticon {
    color: #9ca3af;
  }

  .input.ant-input::placeholder,
  .input.ant-input-affix-wrapper > .ant-input::placeholder {
    color: #9ca3af;
  }

  .input.ant-input:hover,
  .input.ant-input-affix-wrapper:hover {
    border-color: #cbd5e1;
  }

  .input.ant-input:focus,
  .input.ant-input-focused,
  .input.ant-input-affix-wrapper-focused,
  .input.ant-input-affix-wrapper:focus-within {
    border-color: var(--primary-color);
    box-shadow: 0 0 0 4px var(--ring);
  }

  /* ---------- Links ---------- */
  .page-link {
    text-decoration: none;
    margin: 0 0 2px 0;
    text-align: end;
    color: var(--muted);
  }

  .page-link-label {
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    color: var(--primary-color);
    transition: opacity 0.2s ease;
  }

  .page-link-label:hover {
    opacity: 0.8;
  }

  /* ---------- Primary button ---------- */
  .form-btn {
    height: 50px;
    padding: 0 16px;
    border-radius: 10px;
    border: 0 !important;
    outline: 0 !important;
    background: var(--primary-color);
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.2px;
    cursor: pointer;
    box-shadow: 0 10px 22px -8px rgba(217, 83, 79, 0.5);
    margin-top: 6px;
    transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;
  }

  .form-btn:hover {
    filter: brightness(1.05);
    box-shadow: 0 14px 28px -8px rgba(217, 83, 79, 0.6);
    transform: translateY(-1px);
  }

  .form-btn:active {
    transform: translateY(0);
    box-shadow: 0 5px 12px -6px rgba(217, 83, 79, 0.5);
  }

  /* ---------- OTA partner marquee ---------- */
  .partner-marquee {
    margin-top: 32px;
  }

  .partner-label {
    margin: 0 0 12px 0;
    text-align: center;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #9ca3af;
  }

  .marquee-viewport {
    position: relative;
    width: 100%;
    overflow: hidden;
    /* fade the edges so logos slide in/out softly */
    -webkit-mask-image: linear-gradient(
      90deg,
      transparent 0,
      #000 12%,
      #000 88%,
      transparent 100%
    );
    mask-image: linear-gradient(
      90deg,
      transparent 0,
      #000 12%,
      #000 88%,
      transparent 100%
    );
  }

  .marquee-track {
    display: flex;
    align-items: center;
    width: max-content;
    gap: 36px;
    animation: marquee 22s linear infinite;
  }

  .marquee-viewport:hover .marquee-track {
    animation-play-state: paused;
  }

  @keyframes marquee {
    from {
      transform: translateX(0);
    }
    to {
      /* half, because the set is duplicated once */
      transform: translateX(-50%);
    }
  }

  .marquee-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    height: 30px;
  }

  .marquee-item img {
    height: 100%;
    width: auto;
    max-width: 92px;
    object-fit: contain;
    /* grayscale + brightness/contrast forces even saturated logos
       (like the blue fevicon) to a true muted grey */
    filter: grayscale(100%) brightness(0.9) contrast(0.9);
    opacity: 0.55;
    transition: filter 0.25s ease, opacity 0.25s ease;
  }

  .marquee-item img:hover {
    filter: grayscale(0%);
    opacity: 1;
  }

  @media (prefers-reduced-motion: reduce) {
    .marquee-track {
      animation: none;
    }
  }

  /* ===================================================================
     LEFT — SaaS showcase (gradient + subtle photo accent)
     =================================================================== */
  .showcase {
    position: relative;
    order: 1;
    flex: 0 0 70%;
    max-width: 70%;
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    background: linear-gradient(210deg, #0f172a 0%, #1e293b 55%, #334155 100%);
    /* overlap the form boundary by 1px to remove the center seam */
    margin-right: -1px;
  }

  /* photo sits very subtly behind the gradient as texture */
  .showcase-bg {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0;
    transform: scale(1.08);
    transition: opacity 1.2s ease-in-out, transform 12s linear;
    z-index: 0;
    mix-blend-mode: overlay;
  }

  .showcase-bg.visible {
    opacity: 0.35;
    transform: scale(1);
  }

  .showcase-overlay {
    position: absolute;
    inset: 0;
    z-index: 1;
    background: linear-gradient(
      210deg,
      rgba(15, 23, 42, 0.65) 0%,
      rgba(15, 23, 42, 0.3) 100%
    );
  }

  /* soft glow accents */
  .showcase-glow {
    position: absolute;
    inset: 0;
    z-index: 1;
    background: radial-gradient(
        600px 300px at 15% 15%,
        rgba(255, 255, 255, 0.22),
        transparent 60%
      ),
      radial-gradient(
        500px 400px at 90% 90%,
        rgba(255, 255, 255, 0.12),
        transparent 60%
      );
  }

  .showcase-content {
    position: relative;
    z-index: 2;
    color: #fff;
    padding: 0 clamp(56px, 7vw, 120px);
    width: 100%;
    max-width: 760px;
    /* leave room for the hanging sign up top */
    margin-top: 130px;
  }

  /* ---------- Hanging logo sign ---------- */
  .hanging-brand {
    position: absolute;
    top: 0;
    left: clamp(56px, 7vw, 120px);
    z-index: 3;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* swing from the top anchor like a hanging sign */
    transform-origin: top center;
    animation: hang-swing 5s ease-in-out infinite;
  }

  /* the thread */
  .hang-thread {
    width: 2px;
    height: 96px;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.15),
      rgba(255, 255, 255, 0.5)
    );
  }

  /* the pin/nail at the very top where the thread attaches */
  .hanging-brand::before {
    content: "";
    position: absolute;
    top: -4px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.12);
  }

  /* the wood board that hangs */
  .hang-card {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    padding: 16px 24px;
    /* wood plank look: warm base + grain streaks + top sheen */
    background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.14) 0%,
        rgba(0, 0, 0, 0.14) 100%
      ),
      repeating-linear-gradient(
        90deg,
        #8a5a2b 0px,
        #a06a33 6px,
        #915e2c 12px,
        #9c6531 18px,
        #875729 24px
      );
    border: 1px solid #6f471f;
    box-shadow: 0 18px 36px -14px rgba(0, 0, 0, 0.7),
      inset 0 1px 0 rgba(255, 255, 255, 0.25),
      inset 0 -2px 4px rgba(0, 0, 0, 0.3);
  }

  /* two small screws/bolts on the top corners of the board */
  .hang-card::before,
  .hang-card::after {
    content: "";
    position: absolute;
    top: 7px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: radial-gradient(circle at 35% 35%, #d9c2a1, #5a3b1a);
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.3);
  }
  .hang-card::before {
    left: 9px;
  }
  .hang-card::after {
    right: 9px;
  }

  .showcase-mark {
    height: 68px;
    width: auto;
    max-width: 280px;
    object-fit: contain;
    /* logo turned white so it reads on the dark wood board */
    filter: brightness(0) invert(1);
  }

  @keyframes hang-swing {
    0%,
    100% {
      transform: rotate(-3deg);
    }
    50% {
      transform: rotate(3deg);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .hanging-brand {
      animation: none;
      transform: rotate(0deg);
    }
  }

  .showcase-title {
    margin: 0 0 18px 0;
    font-size: clamp(30px, 3.2vw, 44px);
    font-weight: 800;
    line-height: 1.15;
    letter-spacing: -0.6px;
    text-shadow: 0 2px 20px rgba(0, 0, 0, 0.25);
  }

  .showcase-sub {
    margin: 0 0 32px 0;
    font-size: clamp(15px, 1.2vw, 17px);
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.9);
    max-width: 560px;
  }

  .feature-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .feature-list li {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    font-size: 15px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.95);
  }

  .feature-list .tick {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    flex: 0 0 24px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.4);
    font-size: 13px;
    font-weight: 700;
  }

  /* ===================================================================
     Responsive
     =================================================================== */
  @media (max-width: 1200px) {
    .showcase {
      flex-basis: 60%;
      max-width: 60%;
    }
    .form-container {
      flex-basis: 40%;
      max-width: 40%;
    }
  }

  @media (max-width: 992px) {
    .showcase {
      display: none;
    }
    .form-container {
      order: 1;
      flex: 1 1 100%;
      max-width: 100%;
    }
    .form-inner {
      max-width: 400px;
    }
  }

  @media (max-width: 480px) {
    .form-container {
      padding: 28px 22px;
      align-items: flex-start;
    }
    .form-inner {
      padding-top: 12px;
    }
    .title {
      font-size: 26px;
    }
  }
`;

export default Login;
